import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createStorageMiddleware, { getStorageState } from 'redux-simple-storage-middleware';

import rootReducer from './reducers';

const storageConfig = {
	key: 'anwb-private-lease',
};
const sessionStorageMiddleware = createStorageMiddleware(storageConfig);
const storageState = getStorageState(storageConfig);

const store = createStore(
	rootReducer,
	storageState,
	composeWithDevTools(applyMiddleware(sessionStorageMiddleware))
);

export default store;
